module.exports = "<div echarts [initOpts]=\"initOpts\" [options]=\"chartOption\" class=\"pie-rose-chart\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/chart/pie-rose-chart/pie-rose-chart.component.html
// module id = ./src/app/shared/components/chart/pie-rose-chart/pie-rose-chart.component.html
// module chunks = main